import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, showDeleteOrRestoreMessage, Select, _formatDate, Icon } from "../utils/commonImports";
import { DatePicker, Alert } from "antd";
import dayjs from "dayjs";
import { _api } from '../auth/Api';
import { customStyleMd } from "../utils/common";
import { _exportToExcel } from "../helper/ExportToExcel";

const columns = [
  {
    title: "Customer",
    dataIndex: "firstName",
    render: (_, record) => (
      <div className="d-flex align-items-center gap-2">
        <Avatar src={record.profileImage || null}>
          {record.firstName?.charAt(0).toUpperCase()}
        </Avatar>
        <div>
          <div>{record.firstName} {record.lastName}</div>
        </div>
      </div>
    ),
  },
  {
    title: "Contact Info",
    dataIndex: "email",
    render: (_, record) => (
      <div>
        <div className="small">{record.contactNo}</div>
        <div className="text-muted small">{record.email}</div>
      </div>
    ),
  },
  { title: "CNIC", dataIndex: "cnic" },
  { title: "City", dataIndex: "city" },
  { title: "User Type", dataIndex: "userType" },
  // {
  //   title: "Verified",
  //   dataIndex: "isVerified",
  //   render: (val) => (
  //     <span className={`badge ${val ? "bg-success" : "bg-danger"}`}>
  //       {val ? "Yes" : "No"}
  //     </span>
  //   ),
  // },
  { title: "Last Activity On", dataIndex: "lastActivityLogDate", render: (lastActivityLogDate) => _formatDate(lastActivityLogDate) },
  { title: "Registered On", dataIndex: "createdAt", render: (createdAt) => _formatDate(createdAt) },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => {
      const color = status === "Pending" ? "warning" : status === "Approved" ? "success" : "info";
      return <span className={`badge bg-${color}`}>{status}</span>;
    }
  },
];

const drpUserTypes = [
  { label: "Social Login", value: "Social Login" },
  { label: "Registration", value: "Registration" },
];

const drpUserStatus = [
  { label: "Active", value: "Active" },
  { label: "Pending", value: "Pending" },
  { label: "Vehicle Bound", value: "VehicleBound" },
  { label: "Otp Verified", value: "OTPVerified" },
];

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterBtnShow, setFilterBtnShow] = useState(true)
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  const [citiesDrp, setCitiesDrp] = useState([]);

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    contactNo: "",
    cnic: "",
    userType: null,
    status: "",
    cityId: null,
    isVerified: null,
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    _getCustomers();
    _getCities();
  }, []);

  const _getCities = async () => {
    try {
      await _api("GET", "Cities/GetCities?CityId=0", null, (res) => {
        if (res.isSuccess) {
          const drp = res.data?.map((x) => ({
            value: x.cityId,
            label: x.cityName,
          }));
          setCitiesDrp(drp)
        }
      })
    } catch (error) {
      console.log("API Error", error?.message)
    }
  }

  const _getCustomers = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      name: filterValues.name || "",
      email: filterValues.email || "",
      contactNo: filterValues.contactNo || "",
      cnic: filterValues.cnic || "",
      userType: filterValues.userType?.label || "",
      city: filterValues.cityId?.label || "",
      createdAtFrom: filterValues.startDate ? dayjs(filterValues.startDate).format("YYYY-MM-DD") : null,
      createdAtTo: filterValues.endDate ? dayjs(filterValues.endDate).format("YYYY-MM-DD") : null,
      status: filterValues.status?.value || "",
      isVerified: filterValues.isVerified,
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };

    try {
      setLoading(true);
      await _api("POST", "User/GetAllUsers", payload, (res) => {
        if (res.isSuccess) {
          setCustomers(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setCustomers([]);
          //Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setCustomers([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch customers" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getCustomers(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    const resetFilters = { name: "", email: "", contactNo: "", cnic: "", userType: null, cityId: null, startDate: null, endDate: null, status: "", isVerified: null, dateFilter: null };
    setFilters(resetFilters);
    setPage(1);
    setShowExp(false);
    _getCustomers(resetFilters, 1, pageSize);
  };

  const handleApply = () => {
    const { name, email, contactNo, cnic, userType, startDate, endDate, cityId, status, isVerified, dateFilter, } = filters;
    if (!name && !email && !contactNo && !cnic && !userType && !startDate && !endDate && !dateFilter && !cityId && !status && !isVerified === null) {
      setShowExp(true);
      return;
    }
    setPage(1);
    _getCustomers(filters, 1, pageSize);
  };

  const _deleteCustomer = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    if (isConfirmed) {
      try {
        await _api('POST', 'PortalUser/SoftDeletePortalUser', { userId: d?.id }, function (res) {
          if (res.isSuccess) {
            Toast.fire({ icon: 'success', title: res.message })
            _getCustomers();
          } else {
            Toast.fire({ icon: 'error', title: res.message })
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const xlsColumns = [
    { title: "User Id", dataIndex: "userId" },
    { title: "First Name", dataIndex: "firstName" },
    { title: "Last Name", dataIndex: "lastName" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "contactNo" },
    { title: "CNIC", dataIndex: "cnic" },
    { title: "Date Of Birth", dataIndex: "dateOfBirth" },
    { title: "City", dataIndex: "city" },
    { title: "User Type", dataIndex: "userType" },
    { title: "Registered On", dataIndex: "createdAt" },
  ]

  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      name: "", email: "", contactNo: "", cnic: "", userType: "", createdAt: "", status: "", isVerified: null,
      page: { pageNo: 0, numberOfRecords: 0 },
    };

    try {
      await _api("POST", "User/GetAllUsers", payload, async (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            createdAt: _formatDate(x.createdAt),
            dateOfBirth: _formatDate(x.dateOfBirth),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Mobile App Users",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Customers" />
      {filterBtnShow && (
        <Card className=" mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={filters.name}
                  onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact No"
                  value={filters.contactNo}
                  onChange={(e) => setFilters({ ...filters, contactNo: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="CNIC"
                  value={filters.cnic}
                  onChange={(e) => setFilters({ ...filters, cnic: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={citiesDrp}
                  value={filters.cityId}
                  onChange={(val) => setFilters({ ...filters, cityId: val })}
                  placeholder="Select City"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={drpUserTypes}
                  value={filters.userType}
                  onChange={(val) => setFilters({ ...filters, userType: val })}
                  placeholder="User Type"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={drpUserStatus}
                  value={filters.status}
                  onChange={(val) => setFilters({ ...filters, status: val })}
                  placeholder="User Status"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.startDate ? dayjs(filters.startDate) : null}
                  onChange={(date) => setFilters({ ...filters, startDate: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // Disable future dates
                    if (current && current > dayjs().endOf("day")) return true;
                    return false;
                  }}
                  placeholder="Registered Date (From)"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.endDate ? dayjs(filters.endDate) : null}
                  onChange={(date) => setFilters({ ...filters, endDate: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // Disable future dates
                    if (current && current > dayjs().endOf("day")) return true;

                    // Disable dates before startDate
                    if (filters.startDate && current < dayjs(filters.startDate)) return true;

                    return false;
                  }}
                  placeholder="Registered Date (To)"
                />
              </div>


            </div>
            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert showIcon message="NOTE: Please fill at least one filter" type="warning" />
                )}
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-sm btn-outline-secondary" onClick={() => setFilterBtnShow(false)}>
                  Reset Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}
      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Customers
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>)}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>

        <CustomTable
          columns={columns}
          dataSource={customers}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: customers.length
          }}
          onChange={handleTableChange}
          options={{
            loading: loading,
            withActions: false,
            showEdit: false,
            showDelete: true,
            showView: false,
            rowKey: "id",
            bordered: true,
            size: "small",
            emptyText: "No Customers found",
            pageKey: 12
          }}
          onDelete={(d) => _deleteCustomer(d)}
        />
      </Card>
    </>
  );
};

export default Customers;